import React from "react";
import '../../Checkout.css';

const ProductDetail = ({ response, checkoutParam }) => {

    return (
        <div>
            <div className="row">
                <div className="detail">
                    <div className="book-detail">
                        <div className="book-detail-left">
                            <img src="../../book.jpg" alt="book"></img>
                        </div>
                        <div className="book-detail-right">
                            <div className="book-title mb-10">Statistics for Terrified Biologists, 2nd Edition</div>
                            <div className="book-desc mb-10">Helmut F. van Emden | July 2019</div>
                            <div className="book-isbn mb-10">ISBN: 978-1-119-56368-6</div>
                            <div className="book-type mb-10">E-Book</div>
                            <div className="book-instock mb-10">In Stock</div>
                        </div>
                    </div>
                    <div className="order-summary">
                        <div className="order-row">
                            <div className="order-col">
                                <label>Subtotal(1 items)</label>
                                <div>Shipping and Tax included</div>
                            </div>
                            <div className="order-col">
                                <label>{checkoutParam.amount} {checkoutParam.presentmentCurrency}</label>
                            </div>
                        </div>
                        <div className="order-row total">
                            <div className="order-col total">
                                <label>Order Total:</label>
                            </div>
                            <div className="order-col total">
                                <label>{checkoutParam.amount} {checkoutParam.presentmentCurrency}</label>
                            </div>
                        </div>
                        {/* {response.returnCode !== '0' ? (
                            <div className="order-row retryBtn">
                                <div className="order-col">
                                    <button className="btn btn-primary" onClick={retry}>Retry</button>
                                </div>
                            </div>) : null} */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductDetail;